import { useEffect, useRef } from "react";
import ErrorMessage from "../../../components/helpers/ErrorMessage";
import Origen from "../../../components/catalogo/Origen"
import MaskedInput from 'rsuite/MaskedInput';
import 'rsuite/Input/styles/index.css';
import 'rsuite/InputGroup/styles/index.css';

////// FORM::Datos del cliente //////
export default function Step2({
    formik,
    catalogo,
    step
}) {
    ////// Obtener el primer imput del form //////
    const clienteRef = useRef(null);

    ////// Mascara para los números de teléfono //////
    const opc = {
        mask: [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
        placeholder: '11-1111-1111'
    };

    ////// Cuando este paso sea visible se pone en foco el primer input //////
    useEffect(() => {
        if (step === 1){
            clienteRef.current.focus();
        }
    },[step])

    const { setFieldValue } = formik;
    ////// Asignar el valor ingresado al campo "contacto" y el nombre del primer usuario porque generalmente es el mismo //////
    ////// aún asi el valor del nombre del primer usuario se puede cambiar //////
    function handleInputCliente(value){
        setFieldValue("contacto", value);
        setFieldValue(`usuarios.${0}.nombre`, value);
    }

    return (
        <div className="w-100">
            <div className="pb-8 pb-lg-10">
                <h2 className="fw-bold text-gray-900">Informaci&oacute;n de Contacto</h2>
                <div className="text-muted fw-semibold fs-6">Cliente, origen, email y un tel&eacute;fono son obligatorios.</div>
            </div>
            <div className="mb-10 fv-row">
                <div className="row">
                    <div className="col-lg-8">
                        <div className="form-floating">
                            <input ref={clienteRef}
                                   type="text"
                                   className="form-control form-control-solid text-uppercase"
                                   id="cliente"
                                   name="cliente"
                                   value={formik.values.cliente}
                                   placeholder="Cliente / Razon Social"
                                   onChange={formik.handleChange}
                                   onBlur={formik.handleBlur}
                                   onInput={(e) => handleInputCliente(e.target.value)}
                            />
                            <label htmlFor="cliente" className={"text-gray-700"}>Cliente / Razon Social</label>
                        </div>
                        <ErrorMessage name={'cliente'}/>
                    </div>
                    <div className="col-lg-4">
                        <Origen data={catalogo.origenes} formik={formik}></Origen>
                        <ErrorMessage name={"origen"} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-8">
                        <div className="form-floating">
                            <input type="text"
                                   className="form-control form-control-solid text-uppercase"
                                   id="contacto"
                                   name="contacto"
                                   placeholder="Contacto"
                                   value={formik.values.contacto}
                                   onChange={formik.handleChange}
                                   onBlur={formik.handleBlur}
                            />
                            <label htmlFor="contacto" className={"text-gray-700"}>Representante / Contacto</label>
                        </div>
                        <ErrorMessage name={'contacto'} />
                    </div>
                    <div className="col-lg-4">
                        <div className="form-floating">
                            <input type={'email'} className="form-control form-control-solid"
                                   id="email"
                                   name="email"
                                   placeholder="E-Mail"
                                   value={formik.values.email}
                                   onChange={formik.handleChange}
                                   onBlur={formik.handleBlur}
                                   onInput={(e) => setFieldValue(`usuarios.${0}.email`, e.target.value)}
                            />
                            <label htmlFor="email" className={"text-gray-700"}>Mail</label>
                        </div>
                        <ErrorMessage name={'email'} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-5">
                        <div className={'form-floating'}>
                            <MaskedInput
                                className="form-control form-control-solid"
                                id="tel_movil"
                                name="tel_movil"
                                value={formik.values.tel_movil}
                                mask={opc.mask}
                                guide={true}
                                showMask={false}
                                keepCharPositions={false}
                                placeholder={opc.placeholder}
                                style={{ width: 'auto' }}
                                onChange={(value) => {
                                    setFieldValue('tel_movil', value);
                                    setFieldValue('usuarios.0.tel_movil', value);
                                }}
                                onBlur={formik.handleBlur}
                            />
                            <label htmlFor="tel_movil" className={"text-gray-700"}>Teléfono Movil</label>
                        </div>
                        <ErrorMessage name={'tel_movil'} />
                    </div>
                    <div className="col-lg-5">
                        <div className="form-floating">
                            <MaskedInput
                                className="form-control form-control-solid"
                                id="tel_oficina"
                                name="tel_oficina"
                                value={formik.values.tel_oficina}
                                mask={opc.mask}
                                guide={true}
                                showMask={false}
                                keepCharPositions={false}
                                placeholder={opc.placeholder}
                                style={{ width: 'auto' }}
                                onChange={(value) => {
                                    setFieldValue("tel_oficina", value);
                                }}
                                onBlur={formik.handleBlur}
                            />
                            <label htmlFor="tel_oficina" className={"text-gray-700"}>Teléfono Oficina</label>
                        </div>
                        <ErrorMessage name={'tel_oficina'} />
                    </div>
                    <div className="col-lg-2">
                        <div className="form-floating">
                            <input type="text" className="form-control form-control-solid"
                                   id="extension"
                                   name="extension"
                                   placeholder="Extensión"
                                   value={formik.values.extension}
                                   onChange={formik.handleChange}
                                   onBlur={formik.handleBlur}
                            />
                            <label htmlFor="extension"
                                   className={"text-gray-700"}>Extensión</label>
                        </div>
                        <ErrorMessage name={'extension'} />
                    </div>
                </div>
            </div>
        </div>
    );
}
